import styled from 'styled-components';
import LoadingImage from '../../Global/LoadingImage/LoadingImage';

export const WaypointsContainer = styled.div`
	margin-bottom: 2rem;
	padding: 1rem;
	& > h2 {
		font-weight: unset;
		font-variation-settings: 'wght' 600;
		margin-bottom: 1.5rem;
	}
`;

export const WaypointContainer = styled.div`
	position: relative;
	display: flex;
	gap: 0.75rem;
	padding: 1.5rem 0.75rem;
	border-top: 1px solid var(--ion-color-medium);
	color: var(--text);
	img {
		border-radius: 5px !important;
		box-shadow: var(--generic-box-shadow) !important;
	}
`;

export const WaypointText = styled.div`
	margin: 0;
	font-size: 0.875rem;
	font-variation-settings: 'wght' 350;
	line-height: 1.6;
	margin-bottom: 5px;
`;

export const WaypointTitle = styled.h3`
	margin: 0 0 0.5rem;
	font-family: var(--title-font);
	font-size: 1.375rem;
	font-variation-settings: 'wght' 500;
	font-weight: unset;
	display: flex;
	align-items: center;
	color: #257226;
	& > span {
		margin-left: -5px;
	}
`;

export const WaypointImageContainer = styled.div`
	aspect-ratio: 1/1;
	min-width: 4.5rem;
	height: 4.5rem;
	position: relative;
`;

export const WaypointImage = styled(LoadingImage)`
	/* position: relative; */
`;

export const Index = styled.span`
	font-family: var(--body-font);
	font-size: 0.75rem;
	font-variation-settings: 'wght' 500;
	border-radius: 50%;
	width: 1.5rem;
	height: 1.5rem;
	display: flex;
	justify-content: center;
	align-items: center;
	background: #257226;//var(--ion-color-secondary);

	text-align: center;
	color: #fff;
	margin-right: 0.5rem;
	line-height: 1;
`;

export const FloatingIndex = styled(Index)`
	position: absolute;
	left: -12px;
	top: 50%;
	transform: translateY(-50%);
	outline: 3px solid var(--ion-color-light);
`;

export const WaypointIconContainer = styled.div`
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	height: max-content;
	opacity: 0.8;
	display: flex;
	align-items: center;
	justify-content: center;
	svg {
		path {
			fill: #fff;
		}
	}
`;
